<template>
  <div style="height: 340px; margin-top: 10px">
    <dv-border-box-4 :color="['#96e1fd', '#4ebee7']">
      <div style="padding: 20px 0 20px 40px">
        <el-carousel trigger="click" height="320px">
          <el-carousel-item>
            <div>
              <h4 style="color: #b3b3b3; font-size: 14px">
                杨晓虎主持召开2023年长丰县赤霉病统防统治工作会议
              </h4>
              <div style="color: #acacac; font-size: 13px">
                <p>
                  3月16日下午长丰县召开赤霉病统防统治工作布置暨作业机手培训会议，全县农技人员、村干部、统防统治植保组织及作业机手、小麦种植户代表等100多人在县农业技术推广中心参加线下培训。会议由县农业农村局党委委员杨晓虎主持。
                </p>
                <p>
                  县农业技术推广中心分管领导，给大家详细讲解了2023年小麦赤霉病统防统治项目乡村分片网格化管理办法。
                </p>
                <p>
                  本次培训标志着2023年小麦赤霉病统防统治工作正式启动，为统防统治工作提供了技术保障，助力长丰县“机械强农”工作取得新成绩。
                </p>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div>
              <h4 style="color: #b3b3b3; font-size: 14px">
                长丰草莓专场推介活动服务采购中标候选人公示
              </h4>
              <div style="color: #acacac; font-size: 13px">
                <p>
                  项目名称：安徽名优农产品暨农业产业化交易会（2023·上海）长丰草莓专场推介活动服务采购项目
                </p>
                <p>招标方式：公开招标 公告发布日期：2023年3月2日</p>
                <p>开标日期：2023年3月8日</p>
                <p>
                  安徽名优农产品暨农业产业化交易会（2023·上海）长丰草莓专场推介活动服务采购中标候选人结果公示如下：
                </p>
                <p>中标人名称：亚果会（上海）企业管理有限公司</p>
                <p>中标价格：9.95万元</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </dv-border-box-4>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen38496/market-zone/policy-carousel.vue